<template>
  <nav class="navbar is-transparent">
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <img
          src="../assets/images/athena_logo_singleline_500.png"
          alt="Athena Consulting | Where Wisdom Wins"
          width="auto"
          height="auto"
        />
      </router-link>

      <div
        class="navbar-burger burger"
        data-target="navbar-menu"
        v-on:click="toggleMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div
      id="navbar-menu"
      class="navbar-menu"
      v-bind:class="['navbar-menu', { 'is-active': menuActive }]"
    >
      <div class="navbar-end">
        <router-link class="navbar-item" to="/">Home</router-link>
        <router-link class="navbar-item" to="/about">About</router-link>
        <router-link class="navbar-item" to="/offerings">Offerings</router-link>
        <router-link class="navbar-item" to="/presence"
          >Business Presence</router-link
        >
        <router-link class="navbar-item" to="/contact">Contact</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  props: {},
  data: function() {
    return {
      menuActive: false,
    };
  },
  methods: {
    toggleMenu: function() {
      this.menuActive = !this.menuActive;
    },
  },
};
</script>
